import { Block, IconButton } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

import { HelpDrawer } from '../../components/ReferenceBar/HelpDrawer/HelpDrawer.tsx';
import { ResizableDrawerLayout } from '../../layout/ResizableDrawerLayout.tsx';
import { setReferenceViewOpen } from '../../redux/features/referenceBarUISlice.ts';
import { selectReferenceBarUI } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { selectDeviceWidth } from '../../redux/features/selectors/uiSelectors.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts';
import { Tkv2ReferenceViewModule } from './Tkv2ReferenceViewModule.tsx';
import { useAutoOpenHelpDrawer } from './hooks/useAutoOpenHelpDrawer.ts';
import { useHelpDrawerPageID } from './hooks/useHelpDrawerPageID.ts';

export const Tkv2ReferenceViewDrawer = ({ children }: PropsWithChildren) => {
  const deviceWidth = useAppSelector(selectDeviceWidth);
  const { referenceViewOpen, selectedDataSheet } = useAppSelector(selectReferenceBarUI);
  const dispatch = useAppDispatch();

  const { pageID } = useHelpDrawerPageID();
  useAutoOpenHelpDrawer({ pageID });

  return (
    <Block className="reference-view-drawer">
      <div className="reference-view-drawer-desktop">
        <ResizableDrawerLayout
          direction="horizontal"
          isOpen={referenceViewOpen}
          onClose={() => dispatch(setReferenceViewOpen(false))}
          drawerContent={
            selectedDataSheet === 'help-drawer' ? (
              <HelpDrawer pageID={pageID} />
            ) : (
              <Tkv2ReferenceViewModule isPopout={false} dataSheet={selectedDataSheet} />
            )
          }
          isResizable
          defaultSize={33}
        >
          {children}
        </ResizableDrawerLayout>
      </div>
      {deviceWidth === 'phone' && (
        <div className="reference-view-drawer-mobile">
          {referenceViewOpen ? (
            <div>
              <div className="reference-view-close-button">
                <IconButton
                  icon="close-circle"
                  variant="tertiary"
                  onClick={() => dispatch(setReferenceViewOpen(false))}
                  ariaLabel="close"
                  iconSize="lg"
                  size="sm"
                  iconColor="textTertiary"
                />
              </div>
              {selectedDataSheet === 'help-drawer' ? (
                <HelpDrawer pageID={pageID} />
              ) : (
                <Tkv2ReferenceViewModule isPopout={false} dataSheet={selectedDataSheet} />
              )}
            </div>
          ) : (
            children
          )}
        </div>
      )}
    </Block>
  );
};
